class RegularExpressionDefinitions {
  PersonNumber = /^(19|20)?[0-9]{0,2}[0-9]{6}[-]?[0-9]{4}$/;
  OrgNr = /\d{6}[-]?\d{4}/;
  PhoneNumber = /\+?[0-9]+/;
  Address = /^[^;]+$/;
  Vat = /^(0|6|12|25)$/;
  TableRowFieldNameRegex = /([\s\S]*)\[([\s\S]*)\]\.([\s\S]*)/;
  Time = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;
  // eslint-disable-next-line no-useless-escape
  FullName = /[a-öA-Ö\-]+( [a-öA-Ö\-]+)+/;
}

const RegularExpressions = new RegularExpressionDefinitions();

export default RegularExpressions;
